import React, { Component } from 'react';
import $ from 'jquery';
import {Tabs, Tab} from 'react-bootstrap';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebCategories extends Component{
	constructor(props){
		super(props);
		this.state={
			key:1,
			cat_names:[],
			cat_items:[],
		}
		this.handleSelect=this.handleSelect.bind(this);
		this.getcategories=this.getcategories.bind(this);
	}
	componentDidMount()
	{
		this.getcategories();
	}
	handleSelect(key)
	{
		this.setState({
			key:key
		});
		var data1=key;
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'getCatByDtype',
			data:{req:data1},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cat_items:data.data,
					});
				}
			}.bind(this),
			error:function(err)
			{}
		})
	}
	getcategories()
	{
		var data1={from:'desktop_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'getNewDtypes',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cat_names:data.data,
						key:data.data[0].id,

					});
					this.handleSelect('{"from":"desktop_web","dtype_id":"'+data.data[0].id+'","type":"'+data.data[0].type+'"}')
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	render()
	{	
		var cat_names='';
		if(this.state.cat_names.length > 0)
		{
			cat_names =this.state.cat_names.map(function(data,index){
				return(
					<Tab eventKey={'{"from":"desktop_web","dtype_id":"'+data.id+'","type":"'+data.type+'"}'} title={data.name} >
					</Tab>
				);
			});
		}
		var cat_items='';
		if(this.state.cat_items.length > 0)
		{
			cat_items=this.state.cat_items.map(function(data,index){
				return(
 						<div className=" col-md-2 col-sm-4 cart_item">
			                <a href={(data.dtype === '1' || data.dtype === 8) ? '/web/'+data.url_dtype_name+'/'+data.url_name+'/'+data.id : '/web/'+data.url+'/'+data.url_dtype_name+'/'+data.url_name+'/'+data.id+'/'+data.category+'/'+data.dtype} className="cat_blk">
			                  <span><img src={data.icon ? baseAssets+'images/icons/'+data.icon : baseAssets+'/icons/web_icons/noImage.png'} alt=""/></span>
			                  {data.title ? <h5>{data.title}</h5> : <h5>&nbsp;</h5>}
			                  {data.count ? <h6>{data.count+' items'}</h6> : <h6>&nbsp;</h6>}
			                </a>
                       	</div>
                );
			});
		}
		return(
			<section className="web_categories_blk">
				<div className="container" style={{padding:'0px'}}><h4>Trending Categories</h4></div>
			  	<div className="container home_category_blk">	
					<Tabs onSelect={this.handleSelect}>
						{cat_names}
					</Tabs>
				    <div className="row">
				        <div className="Block">
				           {cat_items.length > 0 ? cat_items : ""}
				        </div>
				    </div> 
			  </div>
			</section>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/WebCategories.js
 **/